import React from 'react'
import ResourceLinkNav from '../components/shared/ResourceLinkNav/ResourceLinkNav'
import CertificateView from '../components/Certificates/CertificateView'
import AdminView from '../components/shared/AdminView'

function CertificateViewPage() {
  return (
    <ResourceLinkNav>
      <AdminView/>
      <CertificateView />
    </ResourceLinkNav>
  )
}

export default CertificateViewPage